import { useState } from "react";
import { CreateSalaryTypeModel } from "@core/model/query-model-salary-type";
import {
  useQyCreateSalaryType,
  useQyGetSalaryType,
} from "@core/query/salary-type.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownSalaryType = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newSalaryType, setNewSalaryType] = useState<CreateSalaryTypeModel>({
    name: "",
    description: "",
  });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewSalaryType({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newSalaryType.name) {
      showWarning("Please fill in SalaryType details");
      return;
    }
    setIsCreating(true);
    addSalaryType(newSalaryType);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New SalaryType is added. Check and select the SalaryType in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addSalaryType } = useQyCreateSalaryType(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: salaryTypeResponse } = useQyGetSalaryType("");
  const mappedSalaryType = (salaryTypeResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newSalaryType,
    mappedSalaryType,
    isCreating,
    salaryTypeResponse,
    setSidebar,
    setFilter,
    setNewSalaryType,
    handleFilterInput,
    handleAdd,
    addSalaryType,
  };
};
